import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress,
  Box,
} from '@mui/material';

const ConfirmDeleteDialog = ({
  open,
  onClose,
  onConfirm,
  title = 'Confirm deletion',
  message = 'Are you sure you want to delete this item? This action cannot be undone.',
  confirmLabel = 'Delete',
  loading = false,
}) => {
  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '12px',
          boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
          p: 0,
        },
      }}
    >
      <DialogTitle
        sx={{
          fontWeight: 600,
          fontSize: '18px',
          color: '#1a1a1a',
          pt: 2.5,
          px: 3,
          pb: 1,
        }}
      >
        {title}
      </DialogTitle>
      <DialogContent sx={{ px: 3, pt: 0, pb: 2 }}>
        <Typography variant="body2" sx={{ color: '#666', fontSize: '14px', lineHeight: 1.5 }}>
          {message}
        </Typography>
      </DialogContent>
      <DialogActions
        sx={{
          px: 3,
          pb: 2.5,
          pt: 0,
          gap: 1.5,
        }}
      >
        <Button
          onClick={onClose}
          disabled={loading}
          variant="outlined"
          sx={{
            textTransform: 'none',
            fontWeight: 600,
            fontSize: '14px',
            px: 2.5,
            py: 1,
            borderRadius: '8px',
            color: '#43425D',
            borderColor: '#43425D',
            '&:hover': {
              borderColor: '#43425D',
              backgroundColor: 'rgba(67, 66, 93, 0.04)',
            },
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          disabled={loading}
          variant="contained"
          sx={{
            textTransform: 'none',
            fontWeight: 600,
            fontSize: '14px',
            px: 2.5,
            py: 1,
            borderRadius: '8px',
            backgroundColor: '#00043C',
            color: '#fff',
            '&:hover': {
              backgroundColor: '#000652',
            },
          }}
        >
          {loading ? (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <CircularProgress size={16} sx={{ color: 'white' }} />
              Deleting...
            </Box>
          ) : (
            confirmLabel
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDeleteDialog;
